import React from "react";

import Search from "./Search.jsx";

export default function MobileSplash({
    props = { title: 'Resource Library', copy: '' },
    setSecondaryMenu = (menu = []) => { },
    setTertiaryMenu = (menu = []) => { },
    setActiveMenu = (menuItem = {}) => { },
    setUrlPath = (menuItem = {}) => { },
    activeFilters = [],
    createAllMenuItem = (menuItem = {}) => { }
}) {
    
    return (
        <section>
            <header>
                <h2>{ props.title }</h2>
                <p>{ props.copy }</p>
            </header>
            <Search
                {...{
                    setSecondaryMenu,
                    setTertiaryMenu,
                    setActiveMenu,
                    setUrlPath,
                    activeFilters,
                    createAllMenuItem,
                    placeHolder: `Search ${props.title}`,
                    isMobile: true
                }}
            />
        </section>
    );
}

